import React from 'react'

const COPPER    = '#B08D5B'
const NIGHT     = '#1A1D24'
const OFF_WHITE = '#F8F4EC'

type Size = 'sm' | 'md' | 'lg'
type Variant = 'dark' | 'light'

const SIZES = {
  sm: { width: 120, height: 40,  fontSize: 16, accentW: 13, accentH: 3.5, accentX: 67,  accentY: 5,  rx: 20  },
  md: { width: 160, height: 52,  fontSize: 22, accentW: 17, accentH: 4.5, accentX: 90,  accentY: 6,  rx: 26 },
  lg: { width: 220, height: 70,  fontSize: 30, accentW: 23, accentH: 6,   accentX: 123, accentY: 8,  rx: 35 },
}

interface LumeneLogoProps {
  variant?: Variant
  size?: Size
}

const LumeneLogo: React.FC<LumeneLogoProps> = ({ variant = 'dark', size = 'md' }) => {
  const s = SIZES[size]
  const bgColor       = variant === 'dark' ? 'rgba(26,29,36,0.85)' : 'rgba(248,244,236,0.92)'
  const wordmarkColor = variant === 'dark' ? OFF_WHITE : NIGHT

  return (
    <svg
      role="img"
      aria-label="Lumène"
      xmlns="http://www.w3.org/2000/svg"
      width={s.width}
      height={s.height}
      viewBox={`0 0 ${s.width} ${s.height}`}
    >
      <rect x={0} y={0} width={s.width} height={s.height} rx={s.rx} fill={bgColor} />
      <rect
        x={s.accentX}
        y={s.accentY}
        width={s.accentW}
        height={s.accentH}
        rx={1.5}
        fill={COPPER}
        transform={`rotate(22, ${s.accentX + s.accentW / 2}, ${s.accentY + s.accentH / 2})`}
      />
      <text
        x={s.width / 2}
        y={s.height / 2 + s.fontSize * 0.36}
        textAnchor="middle"
        fontFamily="'Atkinson Hyperlegible', system-ui, sans-serif"
        fontSize={s.fontSize}
        fontWeight={400}
        fill={wordmarkColor}
        letterSpacing={0.5}
      >
        Lumene
      </text>
    </svg>
  )
}

export default LumeneLogo
